jQuery_T4NT(document).ready(function ($) {
  /**
   *  Variant selection changed
   *  data-variant-toggle="{{ variant.id }}"
   */

  /************************************************************************************
   ******************** DISABLE CHANGING PRODUCT IMAGE ON HOVER ************************
   ******************************** aslan **********************************************
   *************************************************************************************/

  $(".t4s-product-img").each(function () {
    var imgs = $(this).find("img");
    if (imgs.length > 1) {
      // Remove all images except the first one
      imgs.slice(1).remove();
    }
  });
});
